import { createUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'
import { fetcher } from 'components/shared/fetcher.js'


export const updatePremiumProductPath = (itemId: number, productId: number): string =>
  `xhr/basket/update_premium_product/${itemId}/${productId}/`


const JSON_HEADERS: HeadersInit = {
  'Accept': 'application/json',
}


export const updatePremiumProduct = async (itemId: number, productId: number): Promise<void> => {
  const url = await createUrl(updatePremiumProductPath(itemId, productId))
  const response = await fetcher.fetch(url, { headers: JSON_HEADERS, redirect: 'follow' })

  if (!response.ok) throw new Error(`Request failed with status ${response.status}`)
}
